import { Injectable } from "@angular/core";

@Injectable()
export class ThermalResponses {

    constructor() { }

}

export interface ResponseThermal<T> {
    code: string;
    data: T;
    msg: string;
    result: number;
    success: boolean;
}

export interface ResponseData<T> {
    data: T;
    message: string;
}

export interface ResponsePaging<T> {
    page: number;
    limit: number;
    total: number;
    totalPage: number;
    data: T[];
}

export interface HTTPNativeResponse {
    status: number;
    error: string,
    data: string;
    url: string;
    headers: any;
  }


// WEBPACK FOOTER //
// ./src/shared/thermal/thermal-responses.ts